// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9lYWB","textarea":"styles_textarea__13ava"};